const universityCities = {
    AT: [
        "Vienna",          // University of Vienna, TU Wien
        "Graz",            // University of Graz, TU Graz
        "Innsbruck",       // University of Innsbruck
        "Salzburg",        // University of Salzburg
        "Linz",            // Johannes Kepler University
        "Krems an der Donau", // Danube University Krems
        "Leoben",          // Montanuniversität Leoben
        "Klagenfurt"       // University of Klagenfurt
    ],
    BE: [
        "Brussels",        // Université libre de Bruxelles, VUB
        "Leuven",          // KU Leuven
        "Ghent",           // Ghent University
        "Antwerp",         // University of Antwerp
        "Liège",           // University of Liège
        "Louvain-la-Neuve",// UCLouvain
        "Namur",           // University of Namur
        "Hasselt"          // Hasselt University
    ],
    CH: [
        "Zurich",          // ETH Zurich, University of Zurich
        "Lausanne",        // EPFL, University of Lausanne
        "Basel",           // University of Basel
        "Geneva",          // University of Geneva
        "Bern",            // University of Bern
        "Fribourg",        // University of Fribourg
        "Neuchâtel",       // University of Neuchâtel
        "St. Gallen",      // University of St. Gallen (HSG)
        "Lugano"           // Università della Svizzera italiana (USI)
    ],
    CZ: [
        "Prague",          // Charles University, Czech Technical University
        "Brno",            // Masaryk University, Brno University of Technology
        "Ostrava",         // VSB - Technical University of Ostrava
        "Olomouc",         // Palacký University Olomouc
        "Plzeň",           // University of West Bohemia
        "České Budějovice" // University of South Bohemia
    ],
    DK: [
        "Copenhagen",     // University of Copenhagen, DTU
        "Aarhus",         // Aarhus University
        "Odense",         // University of Southern Denmark
        "Aalborg",        // Aalborg University
        "Roskilde"        // Roskilde University
    ],
    FI: [
        "Helsinki",       // University of Helsinki, Aalto University
        "Tampere",        // Tampere University
        "Turku",          // University of Turku, Åbo Akademi University
        "Oulu",           // University of Oulu
        "Jyväskylä",      // University of Jyväskylä
        "Lappeenranta"    // LUT University
    ],
    FR: [
        "Paris",          // Sorbonne, Sciences Po, Paris-Saclay, etc.
        "Lyon",           // Université Claude Bernard Lyon 1, Lyon 2/3
        "Toulouse",       // University of Toulouse
        "Lille",          // University of Lille
        "Strasbourg",     // University of Strasbourg
        "Bordeaux",       // University of Bordeaux
        "Grenoble",       // Université Grenoble Alpes
        "Nice",           // Université Côte d'Azur
        "Montpellier",    // University of Montpellier
        "Nantes"          // University of Nantes
    ],
    DE: [
        "Berlin",         // HU, TU, FU Berlin
        "Munich",         // LMU, TU Munich
        "Hamburg",        // University of Hamburg
        "Frankfurt",      // Goethe University Frankfurt
        "Heidelberg",     // Heidelberg University
        "Cologne",        // University of Cologne
        "Stuttgart",      // University of Stuttgart
        "Leipzig",        // University of Leipzig
        "Dresden",        // TU Dresden
        "Freiburg"        // University of Freiburg
    ],
    ES: [
        "Madrid",           // Complutense, UAM, Carlos III
        "Barcelona",        // UB, UAB, UPC, Pompeu Fabra
        "Valencia",         // University of Valencia, UPV
        "Granada",          // University of Granada
        "Seville",          // University of Seville
        "Zaragoza",         // University of Zaragoza
        "Bilbao",           // University of the Basque Country
        "Salamanca",        // University of Salamanca
        "Alicante",         // University of Alicante
        "Valladolid"        // University of Valladolid
    ],
    GR: [
        "Athens",           // National and Kapodistrian, NTUA
        "Thessaloniki",     // Aristotle University
        "Patras",           // University of Patras
        "Heraklion",        // University of Crete
        "Ioannina",         // University of Ioannina
        "Volos",            // University of Thessaly
        "Larissa",          // University of Thessaly
        "Xanthi",           // Democritus University
        "Chania",           // Technical University of Crete
        "Rhodes"            // University of the Aegean
    ],
    HU: [
        "Budapest",         // ELTE, BME, Corvinus
        "Debrecen",         // University of Debrecen
        "Szeged",           // University of Szeged
        "Pécs",             // University of Pécs
        "Győr",             // Széchenyi István University
        "Miskolc",          // University of Miskolc
        "Eger",             // Eszterházy Károly University
        "Kecskemét"         // John von Neumann University
    ],
    IE: [
        "Dublin",           // Trinity College, UCD, TU Dublin
        "Cork",             // University College Cork
        "Galway",           // University of Galway
        "Limerick",         // University of Limerick
        "Maynooth",         // Maynooth University
        "Waterford"         // SETU – South East Technological University
    ],
    IT: [
        "Rome",             // Sapienza, Tor Vergata, Roma Tre
        "Milan",            // University of Milan, Politecnico di Milano, Bocconi
        "Bologna",          // University of Bologna
        "Florence",         // University of Florence
        "Naples",           // University of Naples Federico II
        "Turin",            // University of Turin, Politecnico di Torino
        "Padua",            // University of Padua
        "Trento",           // University of Trento
        "Pisa",             // University of Pisa, Scuola Normale Superiore
        "Venice"            // Ca' Foscari University of Venice
    ],
    LT: [
        "Vilnius",          // Vilnius University, Vilnius Tech
        "Kaunas",           // Kaunas University of Technology, Vytautas Magnus University
        "Klaipėda",         // Klaipėda University
        "Šiauliai"          // Šiauliai Academy (part of Vilnius University)
    ],
    LV: [
        "Riga",             // University of Latvia, Riga Technical University, RISEBA
        "Daugavpils",       // Daugavpils University
        "Jelgava",          // Latvia University of Life Sciences and Technologies
        "Liepāja"           // Liepāja University
    ],
    NL: [
        "Amsterdam",        // University of Amsterdam, VU Amsterdam
        "Rotterdam",        // Erasmus University Rotterdam
        "Utrecht",          // Utrecht University
        "Eindhoven",        // Eindhoven University of Technology
        "Groningen",        // University of Groningen
        "Leiden",           // Leiden University
        "Delft",            // TU Delft
        "Nijmegen",         // Radboud University
        "Tilburg",          // Tilburg University
        "Maastricht"        // Maastricht University
    ],
    NO: [
        "Oslo",             // University of Oslo, OsloMet
        "Bergen",           // University of Bergen
        "Trondheim",        // NTNU – Norwegian University of Science and Technology
        "Tromsø",           // UiT – The Arctic University of Norway
        "Stavanger",        // University of Stavanger
        "Kristiansand"      // University of Agder
    ],
    PL: [
        "Warsaw",           // University of Warsaw, Warsaw University of Technology
        "Kraków",           // Jagiellonian University, AGH University
        "Wrocław",          // University of Wrocław, Wrocław University of Science and Technology
        "Poznań",           // Adam Mickiewicz University
        "Gdańsk",           // University of Gdańsk, Gdańsk University of Technology
        "Łódź",             // University of Łódź, Łódź University of Technology
        "Lublin",           // Maria Curie-Skłodowska University
        "Katowice"          // University of Silesia
    ],
    PT: [
        "Lisbon",           // University of Lisbon, NOVA University Lisbon
        "Porto",            // University of Porto
        "Coimbra",          // University of Coimbra
        "Braga",            // University of Minho
        "Aveiro",           // University of Aveiro
        "Évora",            // University of Évora
        "Faro"              // University of Algarve
    ],
    RO: [
        "Bucharest",        // University of Bucharest, Politehnica University
        "Cluj-Napoca",      // Babeș-Bolyai University, UTCN
        "Iași",             // Alexandru Ioan Cuza University, Gheorghe Asachi Technical University
        "Timișoara",        // West University of Timișoara, Politehnica University
        "Brașov",           // Transilvania University
        "Sibiu",            // Lucian Blaga University
        "Constanța",        // Ovidius University
        "Craiova"           // University of Craiova
    ],
    RS: [
        "Belgrade",         // University of Belgrade
        "Novi Sad",         // University of Novi Sad
        "Niš",              // University of Niš
        "Kragujevac",       // University of Kragujevac
        "Subotica",         // Faculty of Economics Subotica (University of Novi Sad)
        "Čačak"             // Faculty of Technical Sciences (University of Kragujevac)
    ],
    SE: [
        "Stockholm",        // Stockholm University, KTH
        "Uppsala",          // Uppsala University
        "Gothenburg",       // University of Gothenburg, Chalmers
        "Lund",             // Lund University
        "Linköping",        // Linköping University
        "Umeå",             // Umeå University
        "Malmö",            // Malmö University
        "Örebro"            // Örebro University
    ],
    SI: [
        "Ljubljana",        // University of Ljubljana
        "Maribor",          // University of Maribor
        "Koper",            // University of Primorska
        "Nova Gorica"       // University of Nova Gorica
    ],
    SK: [
        "Bratislava",       // Comenius University, Slovak University of Technology
        "Košice",           // Pavol Jozef Šafárik University, TU Košice
        "Trnava",           // University of Trnava
        "Nitra",            // Constantine the Philosopher University
        "Žilina",           // University of Žilina
        "Banská Bystrica"   // Matej Bel University
    ],
    EE: [
        "Tartu",            // University of Tartu
        "Tallinn",          // Tallinn University, TalTech
        "Narva"             // Narva College (University of Tartu)
    ],
    IS: [
        "Reykjavik",        // University of Iceland, Reykjavik University
        "Akureyri"          // University of Akureyri
    ],
    LU: [
        "Esch-sur-Alzette", // University of Luxembourg
        "Luxembourg City"   // Some campuses & administrative offices
    ],
    HR: [
        "Zagreb",          // University of Zagreb
        "Split",           // University of Split
        "Rijeka",          // University of Rijeka
        "Osijek",          // Josip Juraj Strossmayer University of Osijek
        "Zadar",           // University of Zadar
        "Dubrovnik"        // University of Dubrovnik
    ],
    GB: [
        "London",          // UCL, Imperial, King's College, LSE
        "Oxford",          // University of Oxford
        "Cambridge",       // University of Cambridge
        "Edinburgh",       // University of Edinburgh
        "Manchester",      // University of Manchester
        "Glasgow",         // University of Glasgow
        "Bristol",         // University of Bristol
        "Birmingham",      // University of Birmingham
        "Leeds",           // University of Leeds
        "Sheffield"        // University of Sheffield
    ],
    TR: [
        "Istanbul",        // Istanbul University, Boğaziçi, ITU
        "Ankara",          // Middle East Technical University, Ankara University
        "Izmir",           // Ege University, Izmir Institute of Technology
        "Bursa",           // Uludağ University
        "Eskişehir",       // Anadolu University, Eskişehir Osmangazi University
        "Konya",           // Selçuk University
        "Antalya",         // Akdeniz University
        "Gaziantep",       // Gaziantep University
        "Samsun",          // Ondokuz Mayıs University
        "Trabzon"          // Karadeniz Technical University
    ]
};

export default universityCities;
